import React, { createContext, useContext, useState } from 'react';
import { getAvailableApps as getAppsFromRegistry } from '../apps';

const AppContext = createContext();

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};

export const AppProvider = ({ children, activeApp, setActiveApp, deploymentInfo }) => {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(false);

  const switchApp = async (appId) => {
    try {
      setLoading(true);
      // In a real implementation, this would call the API to switch apps
      setActiveApp(appId);
      
      // Dispatch event to notify components of app switch
      window.dispatchEvent(new CustomEvent('app-switched', { 
        detail: { appId } 
      }));
      
      return { success: true };
    } catch (error) {
      console.error('Error switching app:', error);
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getAvailableApps = () => {
    // Get apps from registry and add active status
    return getAppsFromRegistry().map(app => ({
      ...app,
      active: activeApp === app.id
    }));
  };

  const value = {
    activeApp,
    apps: getAvailableApps(),
    loading,
    switchApp,
    setActiveApp,
    deploymentInfo
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};
